<template>
  <div>
    <Navbar v-if="$route.name == 'aggregatedreportsettings'"/>
    <Breadcrumb v-if="$route.name == 'aggregatedreportsettings'" />
    <div class="col-12 px-0 mx-0 mt-2">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button 
            class="nav-link active" 
            type="button"
          >
            <fa-icon class="me-2" name="money-bill" />
            Pricing
          </button>
        </li>
      </ul>
      <div class="tab-content mt-3">
        <div class="tab-pane show active">
          <div class="border-0 mx-0 ps-3 col-12">
            <div class="row">
              <div class="col-12">
                <div class="mb-3 d-flex align-items-center">
                  <label class="col-form-label" style="width: 33%; flex-shrink: 0;">VAT rate (%)</label>
                  <div style="width: 58%;">
                    <input 
                      id="aggregated_vat" 
                      class="form-control"
                      v-model="aggregated_vat"
                      @change="savepref('aggregated_vat',aggregated_vat)" 
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3 d-flex align-items-center">
                  <label class="col-form-label" style="width: 33%; flex-shrink: 0;">Aggregated Report price</label>
                  <div style="width: 58%;">
                    <input 
                      id="aggregated_price" 
                      class="form-control"
                      v-model="aggregated_price"
                      @change="savepref('aggregated_price',aggregated_price)" 
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
export default {
  name: 'AggregatedReportSettings',
  mounted() {
    this.prefs_get();
  },
  components: {
    Navbar,
    Breadcrumb
  },
  data: function() {
    return {
      aggregated_price: 0,
      aggregated_vat: 0,
    }
  },
  methods: {
    savepref(key,value) {
      if (key.indexOf('_date') != -1) {
        value = this.format_date(value);
      }
      this.$store.dispatch('syspref_save', { key: key,value: value });
    },
    prefs_get() {
      this.$store.dispatch('syspref_fetch', { key: 'aggregated_price' })
      .then((resp) => {
        this.aggregated_price = resp.data.value;
        this.$store.dispatch('syspref_fetch', { key: 'aggregated_vat' })
        .then((resp) => {
          this.aggregated_vat = resp.data.value;
        });
      });
    },
  },
}
</script>
<style>
</style>
